<template>
    <v-card
            color="transparent"
            flat
    >
        <v-layout justify-center align-center text-left>

            <div class="text-center pa-4">
                <v-avatar size="65" class="ma-0" color="grey lighten-2">
                    <v-img v-if="avatar" :src="avatar" />
                    <v-icon v-else color="grey">fas fa-user-md</v-icon>
                </v-avatar>
            </div>

            <v-flex xs12 sm10 lg11>
                <v-card-title primary-title>
                    <div>
                        <div class="headline specialist-name" @click="onClickName(specialist)">
                            {{specialist.first_name + ' ' + specialist.last_name}}
                        </div>
                        <div>{{specialist.service_item ? specialist.service_item.description : ''}}</div>
                        <v-card-actions class="pl-0">
                            <v-rating
                                    v-if="ratings && stars"
                                    readonly
                                    v-model="stars"
                                    background-color="secondary"
                                    color="accent"
                                    dense
                                    half-increments
                                    empty-icon="$vuetify.icons.ratingFull"
                                    hover
                                    size="18"
                            ></v-rating>

                            <span v-if="ratings && stars" class="primary--text text--lighten-2 caption ml-2">
                               ({{ stars }} / {{specialist.ratings_summary.count}})
                            </span>
                        </v-card-actions>
                    </div>
                </v-card-title>
            </v-flex>

        </v-layout>

    </v-card>

</template>
<script>
    export default{
        props: ['specialist', 'toProfile', 'ratings'],
        methods:{
          onClickName(entity){
              var vm = this
              vm.$emit('click-name', entity)
              if(typeof vm.toProfile != 'undefined'){
                  vm.$router.push({
                      path: '/providers/' + vm.toProfile + '/profile'
                  })
              }
          }
        },
        computed:{
            avatar(){
              const vm = this
              const settingsAvatar = vm.specialist
                  && vm.specialist.settings
                  && vm.specialist.settings.avatar_image || null

              return settingsAvatar || vm.specialist.avatar

            },
            stars(){
                var vm = this

                if(!vm.specialist || !vm.specialist.ratings_summary || !vm.specialist.ratings_summary.avg){
                    return null
                }

                return Math.round(vm.specialist.ratings_summary.avg * 100) / 100

            },
            starsColor(){
                return this.stars < 3 ? 'accent lighten-2' : 'yellow accent-4'
            }
        }
    }
</script>

<style scoped>

    .specialist-name {
        cursor: pointer;
    }

    .specialist-name:hover{
        color: #3192ff;
    }

    >>>.v-list__tile.v-list__tile--avatar.theme--dark{
        padding:0
    }

    >>>.specialist-item-content{
        height: 100px
    }
</style>
